import React from 'react';
import { Props, Option } from './Switch.types';
import styles from './Switch.module.scss';

const Switch: React.FC<Props> = ({ name, options, onChange, selected, disabled }) => {
  const changeHandler = (option: Option) => {
    return () => {
      if (onChange) {
        onChange(option);
      }
    };
  };

  return (
    <div className={styles.switch}>
      {options.map((option, index) => (
        <React.Fragment key={`option-${name}-${index}`}>
          <input
            type="radio"
            id={`${name}_${option.value}`}
            name={name}
            value={option.value}
            onChange={changeHandler(option)}
            defaultChecked={option.value === selected}
            disabled={disabled}
          />
          <label htmlFor={`${name}_${option.value}`}>{option.label}</label>
        </React.Fragment>
      ))}
    </div>
  );
};

export default Switch;
